import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const Header = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border || '#eee'};
`;

export const ToggleContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const Label = styled.span`
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.text};
`;

export const ContentContainer = styled.div`
    width: 100%;
    animation: fadeIn 0.3s ease-in-out;
    
    @keyframes fadeIn {
        from { opacity: 0; transform: translateY(-5px); }
        to { opacity: 1; transform: translateY(0); }
    }
`;

export const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 15px;
`;

export const ScheduleCard = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${({ theme }) => theme.colors.backgroundSecondary || '#f9f9f9'};
    border: 1px solid ${({ theme }) => theme.colors.border || '#eee'};
    padding: 12px 16px;
    border-radius: 8px;
    transition: box-shadow 0.2s;

    &:hover {
        box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    }
`;

export const ScheduleInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const DayLabel = styled.span`
    font-weight: 700;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.primary || '#333'};
`;

export const TimeLabel = styled.div`
    display: flex;
    align-items: center;
    font-size: 13px;
    color: ${({ theme }) => theme.colors.textSecondary || '#666'};
`;

export const Actions = styled.div`
    display: flex;
    gap: 8px;
`;

export const ActionButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: none;
    background-color: transparent;
    border-radius: 50%;
    cursor: pointer;
    color: ${props => props.isDelete ? '#e74c3c' : props.theme.colors.text};
    transition: background-color 0.2s;

    &:hover {
        background-color: rgba(0,0,0,0.05);
    }
`;

export const LoadingWrapper = styled.div`
    padding: 20px;
    display: flex;
    justify-content: center;
`;

export const EmptyState = styled.div`
    text-align: center;
    padding: 30px;
    color: ${({ theme }) => theme.colors.textSecondary || '#999'};
    background-color: ${({ theme }) => theme.colors.backgroundSecondary || '#f9f9f9'};
    border-radius: 8px;
    border: 1px dashed ${({ theme }) => theme.colors.border || '#ccc'};
`;